import { UpdateSensorsBatchResponseItemModel } from '../models/sensorEntityModels';
import { UpdateSensorsBatchResponseKey, UpdateSensorsBatchResponsePayload } from '../models/sensorPayloadModels';

export const updateSensorsBatchResponseToModel = (payload?: UpdateSensorsBatchResponsePayload): UpdateSensorsBatchResponseItemModel[] => {
  if (!payload) {
    return [];
  }

  const failedUpdates = payload.data[UpdateSensorsBatchResponseKey.FAILURE];

  return failedUpdates.map((item) => {
    const { name, room, sensor_id, sensor_type } = item;

    return {
      name: name ?? '',
      room: room ?? '',
      sensorId: sensor_id ?? '',
      sensorType: sensor_type ?? '',
    };
  });
};
